const byteToMegaByte = (size: number) => {
    const megaByte = size / 1024 / 1024;
    const decimalFix = megaByte.toFixed(2);
    return Number(decimalFix);
};

export default byteToMegaByte;
